import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Menu } from '@sunwebgroup/uds-ui/menu'
import * as React from 'react'
import { useIntl } from '@/intl'
import TopNavigationBarItem from '@/scopes/common/components/Header/TopNavigationBarItem'
import { getLanguageSettings } from '@/scopes/common/domain/policies/siteName'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { isClient } from '@/utilities'
import styles from './LanguageSwitch.module.css'

export function LanguageSwitch() {
  const siteName = useConfiguration('siteName')
  const intl = useIntl()
  const langSettings = getLanguageSettings(siteName)

  if (!langSettings)
    return null

  const matchesLanguageWithUrl = (urlMatcher: string) => {
    if (!isClient())
      return false

    const url = window.location.href
    return url.includes(urlMatcher)
  }

  return (
    <Menu.Root>
      <Menu.Trigger>
        <TopNavigationBarItem className={styles.trigger}>
          <Icon glyph="World" />
          <Icon glyph="ChevronDownExtraSmall" className={styles.arrowIcon} />
        </TopNavigationBarItem>
      </Menu.Trigger>
      <Menu.Content position="bottom-left" className={styles.menuContent}>
        {langSettings.map(setting => (
          <Menu.LinkItem
            href={setting.url}
            key={setting.url}
            glyph={
              matchesLanguageWithUrl(setting.urlMatcher)
                ? 'CheckMarkSmall'
                : undefined
            }
          >
            {intl.formatMessage({ id: `${setting.translationKey}` })}
          </Menu.LinkItem>
        ))}
      </Menu.Content>
    </Menu.Root>
  )
}
